import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultPUR2020_R01Filter, usePUR2020_R01Store } from "./Store_PUR2020_R01";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import {  SearchSpacer } from "src/components/common/common";
import { CompanyDto } from "src/dtos/company/companyDto";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { searchCustomer } from "src/apis/customerApi";

export const SearchSection_PUR2020_R01 = () => {
    const {PUR2020_R01Filter,setPUR2020_R01Filter } = usePUR2020_R01Store();
    const { brandCdList,compCdList,wmsCdList,inoutClassList,itemGroupList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const inboundinoutClassList = inoutClassList.filter(code => code.ref01 === 'IN');

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleCustFoucsId = 'infoCustInput_search';
	const handleItemFoucsId = 'infoItemInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: handleCustFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: PUR2020_R01Filter.customCd || '',
				customNm: PUR2020_R01Filter.customNm || '',
			}),
		},
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PUR2020_R01Filter.itemCd || '',
				itemNm: PUR2020_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR2020_R01Filter,
		setEditData: setPUR2020_R01Filter,
		defaultData: defaultPUR2020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR2020_R01_search'
	});

    return (
        <div className="w-full ">
            <SearchSectionDoubleForm >
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={PUR2020_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setPUR2020_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                <SearchDateRangeForm
                    label="입고기간"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={PUR2020_R01Filter.transportDt}
                    setDateRange={v => setPUR2020_R01Filter({ transportDt: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="입고분류"
                    value={PUR2020_R01Filter.inoutClass}
                    optionList={inboundinoutClassList}
                    onChangeValue={v => setPUR2020_R01Filter({ inoutClass: v === 'all' ? '' : v })}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="창고코드"
                    value={PUR2020_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={v => setPUR2020_R01Filter({ logicCenter: v === 'all' ? '' : v })}
                />
                <SearchSpacer/>

                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={PUR2020_R01Filter.itemGroup}
                    optionList={itemGroupList}
                    onChangeValue={v => setPUR2020_R01Filter({ itemGroup: v === 'all' ? '' : v })}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={PUR2020_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={v => setPUR2020_R01Filter({ brandCd: v === 'all' ? '' : v })}
                    wrapperOption={{
                        wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
                        titleStyle: "w-[45px] min-w-[45px] text-left",
                        selectStyle: "w-[100px] min-w-[100px]",
                    }}
                />
                <SearchCodeModalForm
                    label="거래처"
                    value={PUR2020_R01Filter.customCd}
                    valueLabel={PUR2020_R01Filter.customNm}
                    handleFoucsId={handleCustFoucsId}
                    onChange={getFieldHandlers('customCd').onChange}
                    onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={PUR2020_R01Filter.itemCd}
                    valueLabel={PUR2020_R01Filter.itemNm}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />
            </SearchSectionDoubleForm>
        </div>
    );
};


